import { useState, useRef, useEffect } from 'react';
import { Button, Card, Popover, Tag, Tooltip } from 'antd';
import {
  appointmentStatus,
  appointmentTags,
  customerTagDescriptions,
  strikeTags,
} from '../../../../constants';
import { phoneMask, getFullName } from '../../../../util';
import { hexToRGB } from '../../../../util/colors';
import { PopoverBody } from '../popoverBody';
import { PopoverHeader } from '../popoverHeader';
import './styles.css';
import { MoreOutlined } from '@ant-design/icons';
import { featureFlags } from '../../../../util/featureFlags';

export const AgendaAppointment = ({
  appointment,
  privileges,
  cabain,
  indexTime,
}) => {
  const { customer, appointmentType, treatment, appliedTreatment } =
    appointment;
  const treatmentChanged =
    !!appliedTreatment?.id && appliedTreatment.id !== treatment?.id;
  const treatmentDescription = treatmentChanged
    ? `${treatment?.name} → ${appliedTreatment?.name}`
    : treatment?.name;
  const { mobilePhone } = !!customer && customer;
  let phone = mobilePhone;

  if (customer?.tutor) {
    phone = customer?.tutor?.mobilePhone;
  }

  const [popoverVisible, setPopoverVisible] = useState(false);
  const popoverRef = useRef(null);

  const getAppointmentTags = () => {
    const finishedCount = customer?.finishedAppointments ?? 0;
    const strikes = customer?.strikes ?? 0;
    const wasBanned = customer?.unbanned ?? false;

    const tags = [];

    if (finishedCount === 0) {
      tags.push(
        <Tooltip title={customerTagDescriptions.new}>
          <Tag color="orange">{strikeTags.new}</Tag>
        </Tooltip>
      );
    } else if (finishedCount >= 1 && finishedCount <= 14) {
      tags.push(
        <Tooltip title={customerTagDescriptions.active}>
          <Tag color="green">{strikeTags.active}</Tag>
        </Tooltip>
      );
    } else if (finishedCount >= 15 && finishedCount <= 29) {
      tags.push(
        <Tooltip title={customerTagDescriptions.recurrent}>
          <Tag color="blue">{strikeTags.recurrent}</Tag>
        </Tooltip>
      );
    } else {
      tags.push(
        <Tooltip title={customerTagDescriptions.good}>
          <Tag color="purple">{strikeTags.good}</Tag>
        </Tooltip>
      );
    }

    if (strikes >= 1) {
      tags.push(
        <Tooltip title={customerTagDescriptions.unattendance}>
          <Tag color="gold">{appointmentTags.unattendance}</Tag>
        </Tooltip>
      );
    }

    if (strikes >= 3) {
      tags.push(
        <Tooltip title={customerTagDescriptions.recurrentUnattendance}>
          <Tag color="orange">{appointmentTags.recurrentUnattendance}</Tag>
        </Tooltip>
      );
    }

    if (wasBanned) {
      tags.push(
        <Tooltip title={customerTagDescriptions.banHistory}>
          <Tag color="red">{appointmentTags.banHistory}</Tag>
        </Tooltip>
      );
    }

    return tags;
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target.id !== 'selectConfirmAppointment' &&
      event.target.className !== 'ant-select-selection-item'
    ) {
      setPopoverVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="agenda-appointment">
        <Card
          bordered={true}
          className="appointment-item"
          style={{
            margin: '2px 0 0 0',
            backgroundColor: `rgba(${hexToRGB(
              appointmentStatus[appointment?.status].color,
            )}, 0.15)`,
            color: `#${appointmentStatus[appointment?.status].color}`,
            borderRadius: '0',
          }}
          extra={
            <div ref={popoverRef}>
              <Popover
                overlayClassName="agenda-appointment-popover"
                title={
                  <PopoverHeader
                    appointment={appointment}
                    indexTime={
                      featureFlags.externalAppointment ? indexTime : null
                    }
                    cabain={featureFlags.externalAppointment ? cabain : null}
                    privileges={privileges}
                  />
                }
                content={
                  <PopoverBody
                    appointment={appointment}
                    privileges={privileges}
                  />
                }
                placement="right"
                visible={popoverVisible}
                onVisibleChange={(visible) => setPopoverVisible(visible)}
              >
                <Button
                  type="link"
                  style={{ marginRight: '-20px', marginTop: '0' }}
                  onClick={() => setPopoverVisible(!popoverVisible)}
                >
                  <MoreOutlined />
                </Button>
              </Popover>
            </div>
          }
        >
          <span className="appoitment-content customer">
            {getFullName(customer)}
          </span>
          <span
            className="appoitment-content"
            style={{
              display: 'flex',
              gap: '4px',
              flexWrap: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {getAppointmentTags()}
          </span>{' '}

          <span className="appoitment-content">{appointmentType}</span>
          <span className="appoitment-content">{phoneMask(phone)}</span>
          <Tooltip title={treatmentDescription}>
            <span className="appoitment-content">
              <span className="text-truncate" style={{ display: 'block' }}>
                {treatment?.name}
              </span>
              {treatmentChanged && (
                <span className="text-truncate" style={{ display: 'block' }}>
                  → {appliedTreatment?.name}
                </span>
              )}
            </span>
          </Tooltip>
        </Card>
      </div>
    </>
  );
};
